import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import barListApi from "api/barListApi";
import { formatQueryParams } from "helpers/format";

export const getBarList = createAsyncThunk(
  "BarList",
  async (params: any = {}) => {
    try {
      const response = await barListApi.bars(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getBarDetail =  async(id: string | number ,  params: any = {}) => {
  try{
    const response = await barListApi.getBarDetail(id, params)
    return response;
  }catch (error) {
    return error;
  }
};

export const postBarInformation = async (data: any = {}) => {
  try{
    const response = await barListApi.createBar(data);
    return response;
  }catch (error) {
    return error;
  }
};

export const putBarInformation = async (id: string | number , data: any = {}) => {
  try{
    const response = await barListApi.updateBar(id, data);
    return response;
  }catch (error) {
    return error;
  }
};

export const postVerifyBusinessNumber = async (data: any = {}) => {
  try{
    const response = await barListApi.verifyBusinessNumber(data);
    return response;
  }catch (error) {
    return error;
  }
};